var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-layout__note pc-layout__container"},[_c('tab-sidebar'),_c('router-view'),_c('add-notebook-catalog-dialog'),_c('add-notebook-note-dialog'),_c('rename-dialog'),_c('insert-image-dialog'),_c('upload-image-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }